import { ActivityProgramRequestType } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { activitiesRequestsQueryKeys } from "../../query-keys/events/activities-requests.query-keys";

const getEventActivitiesRequests = async (eventId: string) => {
  const { data } = await privateAxios.get<ActivityProgramRequestType[]>(
    `/events/${eventId}/activities/requests`
  );
  return data;
};

export const useGetEventActivitiesRequestsQuery = (eventId: string) => {
  return useQuery({
    queryKey: activitiesRequestsQueryKeys.event(eventId),
    queryFn: () => getEventActivitiesRequests(eventId),
  });
};
